/**
 * Asynchronously loads the component for EmployerNotifications
 */

import { lazyLoad } from "utils/loadable";

export const AdminNotifications = lazyLoad(
  () => import("./index"),
  (module) => module.AdminNotifications
);
